import useAPIGetDashboard from 'modules/decision/api/dashboard/useAPIGetDashboard';
import { getPublicToken } from 'modules/decision/components/QueryPerimeter/hooks/useGetTreeData';
import { useChartMetadataContext } from 'modules/decision/pages/Explore/components/Contexts/ChartMetadataContext/ChartMetadataContext';
import { getSlugFromDashboardSearchParams } from 'modules/decision/pages/Explore/helpers';
import { useLocation, useParams } from 'react-router';

export const useGetDashboardFromSlugOrMetadata = () => {
    const publicToken = getPublicToken();
    const chartMetadata = useChartMetadataContext();
    const { search } = useLocation();
    const { slug: slugParam } = useParams();
    const slug = getSlugFromDashboardSearchParams(search);

    const { data: dashboard } = useAPIGetDashboard(
        slugParam || slug,
        publicToken,
    );

    if (chartMetadata) return chartMetadata.dashboard;

    if (slug || slugParam) {
        return dashboard;
    }

    return undefined;
};
